<template>
  <div>
    <div class="d-flex justify-content-between ts-mb-3">
      <div>
        <h1 class="page-header ts-mb-0">
          {{ $t('studentScoringEntry.pageTitle') }}
        </h1>
        <p>
          <small>{{ $t('single-copy.title') }}</small>
        </p>
      </div>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('studentScoringEntry.pageTitle'),
            href: '/student-scoring-entries'
          },
          {
            text: $t('studentScoringEntry.singleCopy'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-4">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-md-9">
                <monthlyScore v-model="model" :errors="errors" />
              </div>
              <div class="col-md-3">
                <copy-to-termSemester v-model="model" :errors="errors" />
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-md-12">
                <studentScore v-model="model" :errors="errors" ref="student_score" />
              </div>
            </div>
            <div class="ts-space-x-3 ts-flex ts-justify-end ts-mt-3">
              <ts-button
                @click="$router.push({ name: 'student-scoring-entry' })"
                >{{ $t('cancel') }}</ts-button
              >
              <ts-button color="primary" @click.prevent="onStore">{{
                $t('save')
              }}</ts-button>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import copyToTermSemester from './components/copy-to-term-semester.vue'
import monthlyScore from './components/monthly-score.vue'
import studentScore from './components/student-score.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import notificationAlert from '@/utils/NotificationAlert'

export default {
  name: 'SingleCopy',
  components: {
    copyToTermSemester,
    monthlyScore,
    studentScore
  },
  data() {
    return {
      errors: new Errors(),
      model: {
        acp_id: undefined,
        ac_term_id: undefined,
        grade_id: undefined,
        class_id: undefined,
        ac_year_id: undefined,
        ac_category_id: 0,
        m_scoring_cycle_id: 1, // default value for the select monthly score
        m_cycle_value: undefined,
        scoring_cycle_id: 2, // default value for the select copy to term semester
        cycle_value: undefined,
        score_sc_bas_id: 1, // item base default
        score_type: 1, // numbering score default value
        program_structure_id: undefined,
        sc_item_subject_comp_list: []
      }
    }
  },
  computed: {
    ...mapState('scoreCopy', {
      loading: state => state.loading
    })
  },
  methods: {
    ...mapActions('scoreCopy', ['store']),
    ...mapMutations('scoreCopy', ['SET_LOADING']),
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    onStore() {
      this.SET_LOADING(true)
      this.store(this.model)
        .then(response => {
          notificationAlert(response)
          this.$refs.student_score.getScoreByCycleValue()
        })
        .catch(error => {
          notificationAlert(error)
          this.errors = new Errors(error.errors)
        })
        .finally(() => this.SET_LOADING(false))
    }
  },
  mounted() {
    // Code to run when the component is mounted
  }
}
</script>
